<template>
  <div>
    <div style="display:flex">
      <div style="color:#333;flex:1;text-align: center;">{{type}}分类</div>
      <div style="color:#333;flex:1;text-align: center;">{{type}}名称</div>
    </div>
    <div class="address-container" v-loading="loading">
      <!--左侧分类列表-->
      <div class="address-content">
        <div class="dept-list">
          <el-input
            v-if="typeLists.length > 0"
            placeholder="可搜索科室、病种、分类"
            v-model="filterText">
          </el-input>
          <el-tree
            class="filter-tree"
            ref="tree"
            :data="typeLists"
            node-key="id"
            :props="defaultProps"
            :highlight-current="showTree"
            @node-click="handleNodeClick"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
          ></el-tree>
        </div>
      </div>
      <!--右侧某分类下问卷-->
      <div class="dept-choose-doctors" v-loading="loading1">
        <div style="display:flex;">
          <el-input
            style="flex:1"
            placeholder="可搜索宣教名称"
            v-model="searchText"
            @keyup.enter.native="getQuesList">
          </el-input>
          <Button
                  type="primary"
                  shape="circle"
                  @click="getQuesList()"
                  style="margin-left:10px"
                >搜索</Button>

        </div>
        <div class="doctor-list-item" v-for="(i, index) in quesList" :key="index">
          <el-checkbox-group v-model="Radiovalue" @change="selectRadio">
            <el-checkbox :label="i.news_id">&nbsp;{{ i.news_name }}</el-checkbox>
          </el-checkbox-group>
        </div>

        <div
          v-if="quesList.length === 0 && !loading &&!loading1"
          style="line-height: 40px; text-align: center; color: #c5c8ce"
        >暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
let qs = require('qs')

export default {
  name: 'ConditionFilter',
  props: {
    info: {
      type: Object,
      default: '',
    },
  },
  data() {
    return {
      filterText: '',
      searchText:'',
      list: [],
      quesList: [],
      quesId: '',
      quesInfo: {},
      defaultProps: {
        children: 'children',
        label: 'text',
      },

      type: '宣教',
      typeLists: [],
      text: '',
      showTree: true,
      Radiovalue: [],
      isModalShow: false,
      haveData: true,
      loading: true,
      loading1: false,
    }
  },
  computed: {
    windowHeight: function () {
      return window.innerHeight
    },
  },
  watch: {
    info(newVal) {
      if (newVal) {
        console.log(newVal)
        this.filterText = ''
        this.searchText = ''
        this.getQues()
      }
    },
    filterText(val) {
        this.$refs.tree.filter(val);
    },
  },
  methods: {
    filterNode(value, data, node) {
        if (!value) return true;
        let parentNode = node.parent, labels = [node.label], level = 1
        while (level < node.level) {
          labels = [...labels, parentNode.label]
          parentNode = parentNode.parent
          level++
        }
        return labels.some(label => label.indexOf(value) !== -1)
    },
    handleNodeClick(data) {
      this.typeCode = data.id
      this.Radiovalue = []
      if(data.level && data.level >= 2){
        this.getQuesList()
      }
    },

    getQues() {
      var self = this
      self.quesList = []
      self.loading = true
      self.$utils.caringRequest({
        method: 'GET',
        url: this.info.url,
        withoutToken: true,
        headers: {
          tenant: this.info.hospital,
        },
        success: (res) => {
          self.loading = false
          if (res.code === 0) {
            // self.typeLists = res.data
            self.typeLists = (res.data || []).map(d => {
                d.id = d.dept_id;
                d.text = d.dept_name;
                d.children = (d.diseases || []).map(di => {
                  di.text = di.disease_name;
                  di.id = di.disease_id
                  return di;
                });
                return d;
              });
            if (res.data.length == 0) {
              self.loading1 = false
              self.Radiovalue = []
              self.quesList = []
              self.$emit('selectionData', [])
              return
            }
            // self.typeCode = res.data[0].id
            // self.getQuesList()
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
    getQuesList() {
      var self = this
      self.quesList = []

      self.loading1 = true
      self.$utils.caringRequest({
        method: 'GET',
        url: self.info.category_url,
        data: {
          category_id: self.typeCode,
          size: 999,
          page: 1,
          name: self.searchText
        },
        withoutToken: true,
        headers: {
          tenant: this.info.hospital,
        },
        success: function (res, response) {
          self.loading1 = false
          self.total = Number(response['x-total-count']) || 0
          if (res.code === 0) {
            self.Radiovalue = []
            self.$emit('selectionData', [])
            self.quesList = res.data
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },

    selectRadio(data) {
      console.log(data)
      let arr = []
      data.forEach((v) => {
        this.quesList.forEach((j) => {
          if (v == j.news_id) {
            arr.push(j)
          }
        })
      })
      console.log(arr)
      this.$emit('selectionData', arr)
    },
  },
  mounted() {
    console.log(this.info)
    this.getQues()
  },
}
</script>

<style lang="less" >
.address-container {
  margin-top: 12px;
  display: flex;
  border-radius: 4px;
  border: solid 1px #eee;

  .address-content {
    width: 0;
    flex: 1;
    border-right: solid 1px #eee;
    background: #f8f8f8;
    .dept-list-search {
      padding: 10px 12px;
      border-bottom: solid 1px #eee;
    }

    .dept-list {
      padding: 10px 12px;
      height: 400px;
      overflow-y: auto;
      .el-tree {
        background: #f8f8f8;
      }
      .dept-list-item {
        height: 24px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        .dept-list-item-active {
          color: #000;
          font-weight: bold;
        }
      }
      .el-tree-node__label {
        font-size: 16px;
      }
    }
  }

  .dept-choose-doctors {
    flex: 1;
    padding: 10px 12px;
    overflow-y: auto;
    height: 400px;
    .doctor-list-item {
      overflow: hidden;
      // white-space: nowrap;
      text-overflow: ellipsis;
      .el-checkbox {
        color: #606266 !important;
        font-weight: normal;
      }
      .el-checkbox__label {
        font-size: 15px;
        line-height: 32px;
      }
    }
  }
  .el-tree-node__content {
    height: 32px;
  }
  .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: #e6f0ff;
  }
  .is-leaf .el-tree-node__label,
  .el-tree-node__children .el-tree-node__content {
    color: #999;
  }
}
</style>
